/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Box } from "@mui/system";
import { useEffect } from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";

const strikeThroughStyle = css`
  border-top: 1px solid;
  position: relative;
  top: 16px;
  width: 80%;
  left: 4px;
`;
const previewStyle = css`
  display: flex;
  justify-content: space-evenly;
  width: 150px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  background: aliceblue;
  cursor: not-allowed;
`;

const CapthchGenerator = ({ captchaValue, setCaptchaValue, validate }) => {
  const fonts = ["cursive", "sans-serif", "serif", "monospace"];

  const generateCaptcha = async () => {
    let value = btoa(Math.random() * 1000000000);
    value = value.substr(0, 5 + Math.random() * 3);
    await setCaptchaValue(value);
  };

  const setCaptcha = () => {
    let html1 = captchaValue
      .split("")
      .map((char, i) => {
        const rotate = -20 + Math.trunc(Math.random() * 20);
        const font = Math.trunc(Math.random() * fonts.length);
        return `<div
          key=${i + char}
          style="transform: rotate(${rotate}deg);
          font-size: large;
            font-family: ${fonts[font]}"
        >
          ${char}
        </div>`;
      })
      .join("");
    document.querySelector(".preview").innerHTML = html1;
  };

  useEffect(() => {
    (async () => {
      (await captchaValue) === "" && generateCaptcha();
      await setCaptcha();
    })();
  }, [captchaValue]);

  const preventCopyPaste = (e) => {
    e.preventDefault();
    alert("Copying and pasting is not allowed!");
  };

  return (
    <Box sx={{ position: "relative", bottom: " 23px" }}>
      <Box css={strikeThroughStyle} />

      <div css={{ display: "flex", alignItems: "end" }}>
        <Box
          className="preview"
          css={previewStyle}
          onCopy={(e) => preventCopyPaste(e)}
          onPaste={(e) => preventCopyPaste(e)}
          onCut={(e) => preventCopyPaste(e)}
        ></Box>

        {validate ? (
          <RefreshIcon fontSize="small" onClick={generateCaptcha} />
        ) : (
          <DoneOutlineIcon fontSize="small" color="success" />
        )}
      </div>
    </Box>
  );
};

export default CapthchGenerator;
